'use client';

import { Stack, Typography } from '@mui/material';

import { useGA } from '@/hooks/useGA';
import { useGoogleCalendar } from '@/providers';

import HexagonalButton from './bases/HexagonalButton';

export const CTASection = () => {
  const { showModal } = useGoogleCalendar();
  const { trackButtonClickEvent } = useGA();

  return (
    <Stack
      width={'100%'}
      height={'100%'}
      flexGrow={1}
      paddingX={{ xs: '24px', sm: '80px' }}
      paddingY={{ xs: '32px', sm: '80px' }}
      alignItems={'center'}
      justifyContent={'center'}
      component={'section'}
      position={'relative'}
      sx={{
        minHeight: { xs: '400px', sm: '720px' },
      }}>
      <Stack
        gap={{ xs: 3, sm: 5 }}
        width={'min(1280px, 100%)'}
        zIndex={2}
        alignItems={'center'}
        paddingX={{ xs: 0, sm: '80px' }}>
        <Typography
          component={'h2'}
          fontSize={{ xs: '40px', sm: '72px' }}
          lineHeight={{ xs: '56px', sm: '88px' }}
          fontWeight={500}
          className={'clip-text'}
          textAlign={'center'}
          textTransform={'uppercase'}
          sx={{ background: 'linear-gradient(90deg, #A9A9A9 0%, #FFFFFF 50%, #A9A9A9 100%)' }}>
          Build Your Global Team With Confidence
        </Typography>
        <Typography
          fontSize={{ xs: '18px', sm: '24px' }}
          lineHeight={{ xs: '22px', sm: '32px' }}
          variant={'bodyLarge'}
          color={'#FFFFFF'}
          textAlign={'center'}
          sx={{ opacity: 0.65 }}>
          Global hiring, payroll and compliance – simplified
        </Typography>
        <Stack>
          {/* Desktop Button */}
          <Stack display={{ xs: 'none', sm: 'flex' }}>
            <HexagonalButton
              variant={'primary'}
              label={'CONTACT US'}
              width={191}
              height={52}
              onClick={() => {
                trackButtonClickEvent({ name: 'contact_us' });
                showModal();
              }}
            />
          </Stack>
          {/* Mobile Button */}
          <Stack display={{ xs: 'flex', sm: 'none' }}>
            <HexagonalButton
              variant='primary'
              label='CONTACT US'
              width={140}
              labelClassName='!text-[24px]'
              zoom={0.8}
              onClick={() => {
                trackButtonClickEvent({ name: 'contact_us' });
                showModal();
              }}
            />
          </Stack>
        </Stack>
      </Stack>
    </Stack>
  );
};
